import 'css-chunksrc/client/scenes/moveElement/projectsSelection/input/styles.scss';export default {
  "input": "_input_1bxhn_1",
  "opened": "_opened_1bxhn_20",
  "toggleIcon": "_toggleIcon_1bxhn_25",
  "placeholder": "_placeholder_1bxhn_39",
  "folder": "_folder_1bxhn_46",
  "icon": "_icon_1bxhn_58",
  "tagIcon": "_tagIcon_1bxhn_70"
};